<template>
  <div>
    <el-select v-model="activeSale" placeholder="请选择" :size="size">
      <el-option
        v-for="item in saleListOptions"
        :key="item.id"
        :label="item.location"
        :value="item.id"
        :disabled="!item.saleStatus">
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'saleItem',
    event: 'change'
  },
  props: ['saleItem','size', 'all'],
  data() {
    return {
      saleList: [],
      activeSale: null
    }
  },
  watch: {
    saleItem:{
      handler(val) {
        this.activeSale = val;
      },
      immediate: true
    },
    activeSale: {
      handler(val) {
        this.$emit('change', val)
      },
      deep: true
    }
  },
  computed: {
    saleListOptions() {
      if(this.all) {
        return [{ id: '', location: '全部' }, ...this.saleList];
      }else{
        return this.saleList;
      }
    }
  },
  mounted() {
    this.getSaleList();
  },
  methods: {
    getSaleList() {
      // let localData = localStorage.getItem('saleList');
      // if(localData !== void 0 && localData !== null && localData) {
      //   this.saleList = JSON.parse(localData).filter(v=>v['saleStatus']);;
      //   return;
      // }
      let data = {
        pageSize: 10000,
        pageNum: 1
      };
      this.$q.preSalePlan.planSaleList({data})
      .then(res=>{
        if(res.success && res.data) {
          let saleList1 = res.data.records.filter(v=>v['saleStatus']);
          let saleList2 = res.data.records.filter(v=>!v['saleStatus']);
          this.saleList = [...saleList1, ...saleList2];
          // localStorage.setItem('saleList', JSON.stringify(res.data.list));
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>

</style>
